import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Aboutcard from "./AboutCard";
import laptopImg from "../../Assets/conocenos.jpg";
import Mision from "./Mision";
import Vision from "./Vision";

function About() {
  return (
    <Container fluid className="about-section">
      <Particle />
      <Container>
        <Row style={{ justifyContent: "center", padding: "10px" }}>
          <Col
            md={7}
            style={{
              justifyContent: "center",
              paddingTop: "30px",
              paddingBottom: "50px",
            }}
          >
            <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
               <strong className="purple">Conocenos</strong>
            </h1>
            <Aboutcard />
          </Col>
          <Col
            md={5}
            style={{ paddingTop: "120px", paddingBottom: "50px" }}
            className="about-img"
          >
            <img src={laptopImg} alt="about" className="img-fluid" />
          </Col>
        </Row>
        <Vision/>
        <Mision/>
        <Row>
          <p className="home-about-body">
          En <span className="purple">NAAN</span> buscamos crecer junto con nuestros
          clientes, siendo proveedores de recursos y
          soluciones para los problemas que día a día
          enfrentan en su trabajo.
          </p>
        </Row>
      </Container>
    </Container>
  );
}

export default About;
